import { z } from 'zod';

/**
 * Ortam degiskenlerinin TEK kapisi.
 *
 * Uygulamanin baska hicbir dosyasi `import.meta.env`e dogrudan bakmaz — eslint
 * bunu `no-restricted-syntax` ile hata yapar (bkz. eslint.config.js). Sebep:
 * Vite eksik bir VITE_* degiskenini sessizce `undefined` birakir; yazim hatasi
 * derlemede degil, aylar sonra uretimde bos bir API adresi olarak ortaya cikar.
 * Burada zod ile dogrulanir ve varsayilanlar TEK yerde durur.
 */
const envSchema = z.object({
  /**
   * Uygulamanin servis edildigi alt yol. Vite'in `base` degeri; calisma
   * zamanindaki karsiligi import.meta.env.BASE_URL'dir (bkz. src/app-base.ts).
   */
  VITE_BASE_PATH: z.string().default('/'),

  /**
   * API kokeni. BOS = AYNI KOKEN (nginx /api'yi backend'e proxy'ler; gelistirmede
   * vite dev proxy ayni isi yapar). Dolu ise mutlak adres olarak kullanilir.
   */
  VITE_API_ORIGIN: z.string().default(''),

  /** Profil/hakkinda ekraninda gosterilen surum. */
  VITE_APP_VERSION: z.string().default('0.0.0-dev'),
});

export type AppEnv = z.infer<typeof envSchema>;

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const detail = parsed.error.issues
    .map((issue) => `${issue.path.join('.') || '(kok)'}: ${issue.message}`)
    .join('\n');
  // Derleme degil, ilk import aninda ve yuksek sesle patlar — yanlis
  // yapilandirilmis bir derlemenin uretime sessizce gitmesindense.
  throw new Error(`Ortam degiskenleri gecersiz:\n${detail}`);
}

export const env: AppEnv = parsed.data;

/** API tabani. Bos koken = ayni koken; her iki durumda da /api ile baslar. */
export const API_BASE_URL = `${env.VITE_API_ORIGIN.replace(/\/+$/, '')}/api`;
